<div class="relative w-auto" [style.minWidth]="minWidth">
  <button
    class="w-full h-9 flex justify-between items-center px-4 py-2 rounded-lg transition-colors gap-2"
    [class.shadow-md]="hasShadow"
    [ngClass]="getButtonClasses()"
    [attr.data-testid]="dropdownId"
    (click)="toggle()"
  >
    <div class="flex items-center min-w-0 flex-1 overflow-hidden">
      <span
        class="text-[14px] leading-none text-center truncate"
        [class.font-normal]="!selected()"
        [class.font-bold]="selected()"
      >
        {{ placeholder }}
      </span>

      @if (selected()) {
        <span class="text-[14px] leading-none text-center font-normal ml-1 truncate">
          : {{ selected()?.label }}
        </span>
      }
    </div>

    <div class="flex items-center justify-center w-5 h-5 flex-shrink-0 ml-2">
      @if (isOpen()) {
        <i 
          class="fi fi-rr-angle-small-up text-[24px] mt-[1px] leading-none flex items-center justify-center"
          [ngClass]="[arrowColor]"
        ></i>
      } @else {
        <i 
          class="fi fi-rr-angle-small-down text-[24px] mt-[1px] leading-none flex items-center justify-center"
          [ngClass]="[arrowColor]"
        ></i>
      }
    </div>

  </button>

  @if (isOpen()) {
    <div 
      class="absolute z-50 mt-2 w-[250px] bg-white rounded-lg overflow-hidden"
      [class.shadow-lg]="hasShadow"
    >
      <ul class="max-h-40 overflow-y-auto custom-scroll">
        @for (option of options; track option.value) {
          <li
            (click)="select(option)"
            (keydown.enter)="select(option)"
            (keydown.space)="select(option)"
            class="flex items-center gap-3 p-2 cursor-pointer transition-colors pl-4"
            [ngClass]="getOptionClasses(option)"
            [class.bg-blue-100]="selected()?.value === option.value && !selectedBgColor"
            [class.text-blue-600]="selected()?.value === option.value && !selectedTextColor"
            [class.border-l-4]="selected()?.value === option.value"
            [class.border-blue-600]="selected()?.value === option.value && !selectedBorderColor"
            [class.hover:bg-gray-100]="selected()?.value !== option.value && !hoverBgColor"
            [class.text-gray-800]="selected()?.value !== option.value && !optionTextColor"
          >
            <span class="flex-1">{{ option.label }}</span>
          </li>
        }
      </ul>
    </div>
  }
</div>
